<template>
  <hm-content title="预约列表">
    <div class="table-panel flex flex-end">
      <el-select
        clearable
        v-model="storeOutletId"
        placeholder="选择门店"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          v-for="item in storeList.list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="serverId"
        placeholder="选择服务"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          v-for="item in serviceList.list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateAndTime"
        type="datetimerange"
        align="right"
        start-placeholder="预约开始时间"
        end-placeholder="预约结束时间"
        :default-time="['00:00:00', '23:00:00']"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="keyWord"
        placeholder="输入会员姓名/手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <div class="hm-radio-group">
        <el-radio-group v-model="status" size="small" @change="switchTab">
          <el-radio-button label=""
            >全部({{ appointmentListInfo.totNum }})</el-radio-button
          >
          <el-radio-button :label="4"
            >待审核({{ appointmentListInfo.waitNum }})</el-radio-button
          >
          <el-radio-button :label="0"
            >已预约({{ appointmentListInfo.orderNum }})</el-radio-button
          >
          <!-- <el-radio-button :label="1">已完成({{appointmentListInfo.doneNum}})</el-radio-button> -->
          <el-radio-button :label="2"
            >已过期({{ appointmentListInfo.outNum }})</el-radio-button
          >
          <el-radio-button :label="3"
            >取消预约({{ appointmentListInfo.cancelNum }})</el-radio-button
          >
          <el-radio-button :label="5"
            >已驳回({{ appointmentListInfo.backNum }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        stripe
        border
        :data="appointmentListInfo.pageModel.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverName"
          label="预约服务"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="140px"
          prop="startDateFormat"
          label="预约时段"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverGuider"
          label="预约技师"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="门店"
        >
          <!-- <template slot-scope="scope">{{scope.row.storeOutletId ? scope.row.storeOutlet : '全部门店'}}</template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="状态"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTimeFormat"
          width="140px"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="备注"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text"
                       size="small"
                       @click="cancle(scope.row.id)"
                       v-show="scope.row.status === 4">取消预约</el-button> -->
            <el-button
              type="text"
              size="small"
              @click="deleteAppointment(scope.row.id)"
              >删除预约</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="appointmentListInfo.pageModel.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      keyWord: "",
      storeOutletId: "",
      serverId: "",
      status: "",
      currentPage: 1,
      startDate: "",
      endDate: "",
      dateAndTime: "",
      pageSize: 10,
      btnList: [
        { name: "全部" },
        { name: "已预约" },
        { name: "已付款" },
        { name: "消费中" },
        { name: "服务结束" },
        { name: "取消预约" },
        { name: "已驳回" }
      ]
    };
  },
  mounted() {
    this.queryList();
    this.$store.dispatch("queryServiceList", { pageSize: 999 });
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  computed: mapGetters(["appointmentListInfo", "serviceList", "storeList"]),
  watch: {
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("appointmentList", {
        keyWord: this.keyWord,
        storeOutletId: this.storeOutletId,
        serverId: this.serverId,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    cancle(id) {
      this.$confirm("取消当前预约?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("cancleAppointment", {
            id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "取消预约成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    deleteAppointment(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteAppointment", {
            id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "删除预约成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}
</style>
